<template>
  <div class="bb-contact-service-provider-history">
    <div class="bb-contact-service-provider-history__table">
      <ContactHistoryVendorTable :columns="columns"
                                :rows="rows"
                                :sticky="true"
                                @delete="deleteHistory"
                                @save="updateTable"/>
    </div>
    <div class="bb-button-dashed bb-contact-service-provider-history__button-add"
         @click="addNewEntry">
      <i class="icon-cross"/>Add new
    </div>
    <Pagination :data="fullInfo" :getQuery="getHistories" :limit="defLimit" class="bb-pagination"/>
  </div>
</template>

<script>
import ContactHistoryVendorTable
  from '@/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyVisas/ContactHistoryVendorTable'
import Pagination from '@/components/Main/Pagination/Pagination'
import ServiceProviderHistoryApi from '@/api/ServiceProviderHistory/api'
import {filter, findIndex,} from 'lodash'
import {vendorHistoryTableColumns} from '@/constants/TablesOptions/vendorHistoryTable'
import UsersListApi from '@/api/UsersList/api'

export default {
  name: 'ContactCompanyHistory',
  components: {
    ContactHistoryVendorTable,
    Pagination
  },
  data () {
    return {
      columns: [],
      rows: [],
      fullInfo: {},
      currentPage: 1,
      defLimit: 50
    }
  },
  computed: {
    activeTabRoute() {
      return this.$route.name;
    },
    users: {
      get: function () {
        return this.$store.getters.usersList
      },
      set: function (data) {
        this.$store.dispatch('setUsersList', data)
      }
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    serviceId () {
      return this.$route.params.id
    }
  },
  methods: {
    addNewEntry () {
      const hasNew = findIndex(this.rows, {id: 'new'}) !== -1
      if (hasNew) return
      const history = {
        id: 'new',
        serviceProvider: this.serviceId,
        eventDate: new Date(),
        projectName: '',
        comment: '',
        rating: 1,
        projectFile: [],
        commentFile: [],
      }
      this.rows.push(history)
    },
    updateTable (history) {
      const id = history.id
      id === 'new' ? this.createHistories(history) : this.updateHistories(history)
    },
    async deleteHistory (history) {
      const id = history.id;
      const index = findIndex(this.rows, {id: id});
      try {
        this.$emit('loader', true);
        await ServiceProviderHistoryApi.deleteHistory(id);
        if (index !== -1) this.rows.splice(index, 1);
        await this.getHistories({});
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('loader', false);
      }
    },
    async getHistories ({page}) {
      try {
        this.$emit('loader', true);
        const { data } = await ServiceProviderHistoryApi.getHistories({
          limit: this.defLimit,
          page,
          serviceProvider: this.serviceId
        });
        this.fullInfo = data;
        this.rows = data.serviceproviderhistories;
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('loader', false);
      }
    },
    async createHistories (newHistory) {
      const history = this._createBody(newHistory)
      try {
        await ServiceProviderHistoryApi.createHistory(history);
        await this.getHistories({});
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('loader', false);
      }
    },
    async updateHistories (newHistory) {
      const history = this._createBody(newHistory);
      history.id = newHistory.id;

      try {
        this.$emit('loader', true);
        await ServiceProviderHistoryApi.updateHistory(history);
        await this.getHistories({});
      } catch (err) {
        console.error(err);
      } finally {
        this.$emit('loader', false);
      }
    },
    _createBody(newHistory) {
      const {  height, commentFile, projectFile, ...restHistory} = newHistory;
      const getFile = (file) => {
        if (Array.isArray(file)) {
          return file[0] && file[0].id ? [file[0].id] : []
        }

        return file && file.id ? [file.id] : []
      }

      return {
        serviceProvider: this.serviceId,
        commentFile: getFile(commentFile),
        projectFile: getFile(projectFile),
        ...restHistory
      }
    },
    getUserList () {
      this.$emit('loader', true)
      UsersListApi.getUsersList({limit: 100})
        .then((resp) => {
          this.users = filter(resp.data.users, item => item)
          vendorHistoryTableColumns.forEach(item => {
            if (item.prop === 'user' && Array.isArray(item.options)) {
              item.options = this.users
            }
          })
          this.columns = vendorHistoryTableColumns
          this.$emit('loader', false)
        })
        .catch((err) => {
          console.error(err)
          this.$emit('loader', false)
        })
    }
  },
  beforeMount () {
    this.getUserList()
    this.getHistories({})
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";
@import "../../../../../../sass/mixins";

.bb-contact-service-provider-history {
  @include global-font;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: $color-white;
  margin-top: 20px;
  z-index: 1;
  position: relative;

  &__table {
    margin: 10px 25px;
  }

  &__button-add {
    position: sticky;
    bottom: 0;
    width: calc(100% - 50px);
    margin: 0 25px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ServiceProvider/ServiceProviderHistory/ServiceProviderHistory.vue